<!-- <div class="shape-attribute-panel-component fill-available-height flex-column">
  <div class="inner-container flex-column gap-4">
    <div class="flex-column flex-grow">
      <div
        *ngIf="areThereSelectedShapes$ | async; else fileSettings"
        class="editor-container"
      >
        <nw-if-attribute
          *ngIf="areThereMultiplScenes$ | async"
        ></nw-if-attribute>
        <nw-translate-attribute></nw-translate-attribute>
        <nw-scale-attribute></nw-scale-attribute>
        <nw-rotation-attribute></nw-rotation-attribute>
        <nw-fill-attribute></nw-fill-attribute>
        <nw-stroke-attribute></nw-stroke-attribute>
        <iw-hand-shape-attribute
          *ngIf="onlyHandshapes$ | async"
        ></iw-hand-shape-attribute>
        <nw-drop-shadow-attribute></nw-drop-shadow-attribute>

        <nw-text-attributes
          *ngIf="onlyTextShapes$ | async"
        ></nw-text-attributes>
        <iw-arc-interval-attribute
          *ngIf="onlyCircleShapes$ | async"
        ></iw-arc-interval-attribute>
        <iw-arm-shape-attribute></iw-arm-shape-attribute>
      </div>

      <ng-template #fileSettings>
        <nw-file-settings></nw-file-settings>
      </ng-template>
    </div>

    <ng-container *ngIf="!(isStoryBoardOpened$ | async)">
      <nw-animation-action></nw-animation-action>
      <iw-animation-controller
        *ngIf="!isShapeLoading"
      ></iw-animation-controller>
    </ng-container>
  </div>
</div> -->

<div class="shape-attribute-panel">
  <!-- style="position: absolute; right: 0px; top: 0px" -->
  <nw-stroke-panel
    *ngIf="(selectorState$ | async) == 'stroke'"
    [state]="strokeAttributeState$ | async"
  ></nw-stroke-panel>
  <nw-fill-panel
    *ngIf="(selectorState$ | async) == 'fill'"
    [state]="fillAttributeState$ | async"
  ></nw-fill-panel>

  <!-- <div
    class="content-panel"
    *ngIf="
      (selectorState$ | async) != 'stroke' &&
      (selectorState$ | async) != 'fill' &&
      (selectorState$ | async) != 'animation'
    "
  > -->
  <nw-animation-side-panel></nw-animation-side-panel>
  <!-- </div> -->
</div>
